(() => {
  'use strict';
  if (window.OxydiseLeadAnalytics) return;
  window.OxydiseLeadAnalytics = true;
  const destination = 'G-Z31D647TLK';
  const META_PIXEL = '769185567872630';
  const completed = new WeakSet();
  let phoneRecorded = false;

  function permission() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (window.OxydiseConsentGate?.reloading || privacy?.analyticsProcessingAllowed?.() !== true) return null;
      return { mixed: privacy.marketingAllowed?.() === true && privacy.saleOfDataAllowed?.() === true };
    } catch (_) { return null; }
  }

  function send(name, parameters, fallbackOnly) {
    const state = permission();
    if (!state || (fallbackOnly && state.mixed) || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, { send_to: destination, ...parameters });
    return true;
  }

  function trackLink(event) {
    const link = event.target?.closest?.('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (/^tel:/i.test(href)) {
      if (!phoneRecorded && send('tel_click_copy', {}, true)) phoneRecorded = true;
    } else if (/^mailto:/i.test(href)) {
      send('mail_click_copy', {}, true);
    } else if (event.type === 'click') {
      try {
        const url = new URL(href, window.location.href);
        if (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') send('messenger', {}, true);
      } catch (_) {}
    }
  }

  document.addEventListener('click', trackLink);
  document.addEventListener('copy', trackLink);
  // Enquiry forms are HubSpot's own embed, inside a cross-origin iframe, so GTM's form-submit triggers
  // (which used to send GA4 contact_form and the Meta Lead) cannot see them. Since 18 Oct 2026 this
  // listener is the only source of both, in every consent state, from HubSpot's confirmed success.
  document.addEventListener('pu:hubspot-form:success', event => {
    const form = event.target;
    if (!(form?.matches?.('[data-pu-hubspot-form]') || form?.matches?.('[data-pu-hubspot-native]')) || completed.has(form)) return;
    const kind = ['contact', 'callback', 'email'].includes(form.dataset.puFormKind) ? form.dataset.puFormKind : 'contact';
    if (!send('contact_form', { form_type: kind }, false)) return;
    completed.add(form);
    // Meta Lead, as GTM's tag sent it: only with advertising consent and only on the pixel Shopify's
    // Facebook & Instagram app already loaded (never a second init).
    try {
      if (permission()?.mixed && typeof window.fbq === 'function') window.fbq('trackSingle', META_PIXEL, 'Lead');
    } catch (_) {}
  });
  document.addEventListener('pu:newsletter:success', event => {
    const form = event.target;
    if (!form?.matches?.('[data-pu-form-kind="newsletter"]') || completed.has(form)) return;
    if (send('subscribe', { form_location: form.dataset.puFormLocation || 'footer' }, false)) completed.add(form);
  });
})();
